// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const LEGACY_DATA_IMPORT_TRANSCRIPTION_STEP_SHAPES = [
  {
    stepType: PipelineStepType.LEGACY_DATA_IMPORT_TRANSCRIPTION,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Initiation Results': {
        systemName: 'Initiation Results',
        displayName: 'Initiation Results',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Transcription Results': {
        systemName: 'Transcription Results',
        displayName: 'Transcription Results',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      fileId: {
        kind: 'domain',
        required: true,
        types: [
          'SCRATCH_FILE'
        ]
      },
      filename: {
        kind: 'string',
        required: true
      },
      category: {
        kind: 'string',
        required: true
      },
      refinedPrompt: {
        kind: 'string',
        required: true
      },
      qaCriteria: {
        kind: 'anything',
        required: true
      },
      qaThresholds: {
        kind: 'shape',
        required: true,
        fields: {
          correctnessThreshold: {
            kind: 'number',
            required: true
          },
          completenessThreshold: {
            kind: 'number',
            required: true
          }
        }
      },
      qaGuidelines: {
        kind: 'string',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
